/**
 * Frontend configuration constants
 *
 * Centralized configuration for caching, polling intervals, and pagination.
 * These values should match the backend configuration for consistency.
 */

// ============================================================================
// Homepage Configuration
// ============================================================================

/**
 * Cache TTL for homepage (client-side sessionStorage)
 * Default: 20 minutes
 *
 * How long the homepage data stays in sessionStorage before being considered stale.
 * Should match backend HOME_PAGE_CACHE_TTL for consistency.
 */
export const HOME_PAGE_CACHE_TTL = 20 * 60 * 1000; // 20 minutes (in milliseconds)

/**
 * Auto-check interval for homepage updates
 * DEV: 20 seconds | PROD: 60 seconds
 *
 * How often the client checks for new content.
 * Lower = more fresh, but more API calls.
 * DEV has shorter interval for faster feedback during development.
 */
export const HOME_PAGE_CHECK_INTERVAL =
  process.env.NODE_ENV === 'production'
    ? 60 * 1000  // 60 seconds in production
    : 20 * 1000; // 20 seconds in development

/**
 * Number of articles per page
 * Default: 20
 *
 * Pagination page size for homepage.
 * Should match backend HOME_PAGE_NEWS_COUNT.
 */
export const HOME_PAGE_NEWS_COUNT = 20; // Articles per page

/**
 * Maximum articles to auto-load via infinite scroll
 * Default: 100
 *
 * After this limit, show "Load More" button instead of auto-loading.
 * Prevents performance issues with too many articles in memory.
 */
export const MAX_AUTO_LOAD_ARTICLES = 100; // 5 pages × 20 articles

/**
 * SessionStorage key for homepage snapshot cache
 *
 * Used by both PublicHomepage and ArticleDetail components to share cached data.
 * This ensures article details can access full article data from the homepage snapshot
 * without making additional API calls.
 */
export const HOMEPAGE_CACHE_KEY = "homepage_cache";
